import React from 'react';
import ProjectStartForm from './ProjectStartForm';
import './ContactPage.css';

const ProjectPromotionPage = () => {
  return (
    <div className="contact-page project-promotion-page">
      <div className="urban-renewal-form-wrapper">
        <ProjectStartForm
          sectionId="project-promotion-form"
          address=""
          pageMode
          origin="קידום פרויקטים — דף ייעודי"
        />
      </div>
    </div>
  );
};

export default ProjectPromotionPage;
